/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAccount200Response
 */
export interface CreateAccount200Response {
    /**
     * アカウントID
     * @type {string}
     * @memberof CreateAccount200Response
     */
    accountId: string;
}

/**
 * Check if a given object implements the CreateAccount200Response interface.
 */
export function instanceOfCreateAccount200Response(value: object): value is CreateAccount200Response {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function CreateAccount200ResponseFromJSON(json: any): CreateAccount200Response {
    return CreateAccount200ResponseFromJSONTyped(json, false);
}

export function CreateAccount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['account_id'],
    };
}

export function CreateAccount200ResponseToJSON(json: any): CreateAccount200Response {
    return CreateAccount200ResponseToJSONTyped(json, false);
}

export function CreateAccount200ResponseToJSONTyped(value?: CreateAccount200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['accountId'],
    };
}

